import { render, staticRenderFns } from "./ModalAddAnimais.vue?vue&type=template&id=2fa561fe"
import script from "./ModalAddAnimais.vue?vue&type=script&lang=js"
export * from "./ModalAddAnimais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports